import { memo } from 'react';

import { JourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import {
  JourneyNodeActionCard,
  MoreItems,
  NodeContainer,
} from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { getConditionDescription, getConditionTooltip } from './description';
import { useConditionDescription } from './hooks';

const ACTION_TYPE = ACTION_TYPES.condition_v2;

export const getDescription = (action: JourneyAction<typeof ACTION_TYPE>): string => {
  return getConditionDescription({ values: action.values, styled: false });
};

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  const values = node.data?.values;
  const isConfigured = node.data?.isConfigured;
  const { descriptionText, isTextClamped } = useConditionDescription(values);
  const description = node.data?.description?.trim();
  const hasDescription = Boolean(description);

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={description || descriptionText}
        {...(isConfigured && {
          tooltip: !hasDescription ? getConditionTooltip({ values, isTextClamped }) : '',
          renderBelowDescription: !hasDescription ? <MoreItems items={values?.conditions} /> : '',
        })}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});
